module.exports = __webpack_public_path__ + "@/assets/img/repayment.21650121.png";